var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { BetBtn, BetBtnTypes, OddsUpdateArrowIndicator } from "sb-resp-ui";
import { createBsUtilMsgItem, getBetBtnModifier } from "../../../../helpers";
import { returnValueHelper } from "../../../../../../helpers";
let ML = class ML extends React.PureComponent {
    render() {
        const { pickedEvent, ML, displayMultipleItems, onClick } = this.props;
        const me = pickedEvent.event;
        const market = pickedEvent.market;
        const containerMLClass = returnValueHelper(ML.isRegular(market), "event-money-line-draw", "event-money-line");
        return (React.createElement("div", { className: `rj-superbanner__event-row rj-superbanner__event-row--${containerMLClass}`, "data-uat": `superbanner-event-row-${containerMLClass}` }, market.selections.map((sel) => (React.createElement("div", { key: sel.id, className: "rj-superbanner__bet-button-wrapper", "data-uat": "wrapper-superbanner-bet-button" },
            React.createElement(OddsUpdateArrowIndicator, { odds: sel.trueOdds }),
            React.createElement(BetBtn, { type: BetBtnTypes.ML, modifier: getBetBtnModifier(sel, market.type), odd: sel.formattedOdds, text: ML.getOddName(sel, !displayMultipleItems), isDisabled: sel.isDisabled, handler: onClick(sel, [createBsUtilMsgItem(me, market, sel)]) }))))));
    }
};
ML = __decorate([
    observer
], ML);
export { ML };
//# sourceMappingURL=ML.js.map